import React from 'react';
import { motion } from 'framer-motion';
import LogoMark from '../LogoMark';
import { Timecode } from './Timecode';
import { FichaTecnica } from './FichaTecnica';
import { WhatsButton, WhatsIcon, WA_HREF } from './WhatsButton';
import { trackWhatsAppClick } from '../../utils/analytics';

const rise = (d) => ({
  initial: { opacity: 0, y: 28 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay: d, ease: [0.2, 0.8, 0.2, 1] },
});

const Viewfinder = () => (
  <div className="absolute left-5 right-5 top-24 h-[30vh] lg:left-auto lg:right-10 lg:top-28 lg:w-[44%] lg:h-[46vh] pointer-events-none" data-testid="hero-viewfinder">
    <span className="sh-corner left-0 top-0 border-l-2 border-t-2" />
    <span className="sh-corner right-0 top-0 border-r-2 border-t-2" />
    <span className="sh-corner left-0 bottom-0 border-l-2 border-b-2" />
    <span className="sh-corner right-0 bottom-0 border-r-2 border-b-2" />
    <div className="absolute left-6 right-6 top-6 flex justify-between text-xs sm:text-sm text-[#F2F2EE]">
      <span className="sh-mono flex items-center gap-2"><span className="sh-blink w-2.5 h-2.5 rounded-full bg-[#FF3B30]" />Rec · Cam A</span>
      <Timecode />
    </div>
  </div>
);

export const ShortHero = () => (
  <section className="relative min-h-screen overflow-hidden sh-grain" data-testid="short-hero">
    <img src="/images/hero-flyer.jpg" alt="Cinegrafista da Coutin Studio gravando com câmera profissional" className="absolute inset-x-0 top-0 h-[70vh] w-full object-cover object-top lg:left-auto lg:h-full lg:w-[62%] lg:[mask-image:linear-gradient(to_right,transparent,black_40%)]" />
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0A0B0B]/70 to-[#0A0B0B] lg:bg-gradient-to-t lg:from-[#0A0B0B] lg:via-transparent lg:to-transparent" />
    <Viewfinder />

    <header className="relative z-10 flex items-start justify-between px-6 sm:px-10 lg:px-16 pt-8">
      <LogoMark className="text-[34px] sm:text-[42px]" accent="var(--sh-teal)" />
      <div className="flex items-center gap-6">
        <span className="sh-mono text-[11px] sm:text-sm text-[#F2F2EE] pt-2 lg:pt-0" data-testid="hero-location">Foz do Iguaçu · PR</span>
        <a href={WA_HREF} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('short-header')} data-testid="header-whatsapp-cta" className="hidden lg:inline-flex items-center gap-2 rounded-lg bg-[var(--sh-teal)] text-[#06110F] px-5 py-2.5 font-bold transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#5BEBD5]">
          <WhatsIcon className="w-5 h-5" />Pedir orçamento
        </a>
      </div>
    </header>

    <div className="relative z-10 px-6 sm:px-10 lg:px-16 pt-[36vh] lg:pt-24 pb-16 max-w-[760px]">
      <motion.p {...rise(0.1)} className="sh-mono text-xs sm:text-sm text-[var(--sh-teal)] mb-4">// Produção audiovisual na sua empresa</motion.p>
      <motion.h1 {...rise(0.2)} className="sh-display text-[20vw] sm:text-8xl lg:text-[8.5rem]" data-testid="hero-title">
        Luz.<br />Câmera.<br /><span className="text-[var(--sh-teal)]">Sua marca.</span>
      </motion.h1>
      <motion.p {...rise(0.35)} className="mt-6 text-base sm:text-xl text-[#F2F2EE]/85 max-w-md">
        Levamos o estúdio completo até você. Captamos, editamos e entregamos pronto.
      </motion.p>
      <motion.div {...rise(0.5)} className="mt-10"><FichaTecnica /></motion.div>
      <motion.p {...rise(0.6)} className="sh-mono mt-5 text-[10px] sm:text-xs text-[#F2F2EE]/60 flex items-center gap-3">
        <span className="w-8 h-px bg-[var(--sh-teal)]" />Atendimento exclusivo · Responsabilidade com as contas da sua empresa
      </motion.p>
      <motion.div {...rise(0.7)} className="mt-5"><WhatsButton source="short-hero" testId="hero-whatsapp-cta" /></motion.div>
    </div>
  </section>
);
